import React from "react";
import { createRoot } from "react-dom/client";
import "./index.css";
import App from "./App.js";
import registerServiceWorker from "./registerServiceWorker";
import { AuthProvider } from "./context/auth.context.js";

const domNode = document.getElementById("root");
const root = createRoot(domNode);
root.render(
  <AuthProvider>
    <App />
  </AuthProvider>,
);
registerServiceWorker();
